import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { CardAction } from '../../view/Card/types';
export var combineActionOptions = function combineActionOptions(_ref) {
  var actionOptions = _ref.actionOptions,
    platform = _ref.platform,
    hidePreviewButton = _ref.hidePreviewButton;
  if (typeof actionOptions !== 'undefined') {
    return actionOptions;
  }
  if (platform === 'mobile') {
    return {
      hide: true
    };
  }
  var exclude = [];
  if (hidePreviewButton) {
    exclude = [].concat(_toConsumableArray(exclude), [CardAction.PreviewAction]);
  }
  return {
    hide: false,
    exclude: exclude
  };
};